import { render, staticRenderFns } from "./qNumber.vue?vue&type=template&id=2408becb&scoped=true&"
import script from "./qNumber.vue?vue&type=script&lang=js&"
export * from "./qNumber.vue?vue&type=script&lang=js&"
import style0 from "./qNumber.vue?vue&type=style&index=0&id=2408becb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408becb",
  null
  
)

export default component.exports